// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"3890643c7b7264cd131b","453":"cfee07339a9ae2a90025","522":"28215a50ee4121bf8f95"}[chunkId] + ".js";
};